export const processSeatPlan = ({
	seatPlan, availableSlots, lockedSlots, selectedSlots
}) => {
	return seatPlan.reduce((blocks, block, nth) => {
		const blockNumber = nth + 1;

		const newBlock = {
			...block,
			label: block.title,
			value: blockNumber,
			rows: block.rows.reduce(([rows, curRowNumber], curRow) => {
				const isIncrease = !!(curRow.seats ?? []).find(seat => !seat.isGap);
				const newRowNumber = isIncrease ? curRowNumber + 1 : curRowNumber;
				const newRowNumberDisplay = block.rowType === 'alphabetical' ? block.rowLettering[newRowNumber - 1] : newRowNumber;
		
				const rowSeats = curRow.seats.reduce(([seats, curSeatNumber], curSeat) => {
					const isIncrease = !curSeat.isGap;
					const newSeatNumber = isIncrease ? curSeatNumber + 1 : curSeatNumber;

					const seatKey = `${blockNumber}-${newRowNumber}-${newSeatNumber}`;
					
					const isLocked = lockedSlots?.find(slot => slot.title === seatKey)
					const isSelected = !isLocked ? !!selectedSlots?.find(slot => slot.title === seatKey) : false;
					const matchingSlot = availableSlots?.find(slot => slot.title === seatKey);
					const isAvailable = (!isSelected && !isLocked) ? !!matchingSlot : false;
					
					if(!curSeat.isGap) {
						if(isAvailable || isSelected) {
							return [
								[
									...seats,
									{
										...curSeat,
										label: newSeatNumber,
										isDisabled: !isAvailable,
										value: seatKey,
										selected: isSelected,
										available: isAvailable,
										locked: isLocked,
										unavailable: !isSelected && !isAvailable,
										seatNumber: newSeatNumber,
										slot: {
											...matchingSlot,
											label: `${block.title}, ${newRowNumberDisplay}-${newSeatNumber}`
										},
									},
								],
								newSeatNumber,
							];
						}
						else {
							return [seats, newSeatNumber];
						}
					}
					else {
						return [seats, curSeatNumber];
					}

				}, [[], 0])[0]

				if(isIncrease && rowSeats.length) {
					return [
						[
							...rows,
							{
								...curRow,
								label: newRowNumberDisplay,
								value: newRowNumber,
								rowNumber: newRowNumber,
								rowNumberDisplay: newRowNumberDisplay,
								seats: rowSeats,
							},
						],
						newRowNumber,
					]
				}
				else {
					return [
						[
							...rows,
						],
						newRowNumber,
					]
				}
			}, [[], 0])[0]
		};

		return [
			...blocks,
			...(newBlock.rows.length ? [newBlock] : []),
		]
	}, [])
}

export default processSeatPlan;